import SessionQ from '@/queries/SessionQ'
import TutorAuditQ from '@/queries/TutorAuditQ'
import { SQL } from '@/client/query'

export const statusFilters = {
  All: SQL`TRUE`,
  'No Peer Reviews + Future Session': SQL`${SessionQ.getComputedEndDate()} <= NOW() AND
      NOT EXISTS(SELECT 1 ${TutorAuditQ.where({ sessionId: SessionQ.id })})
      AND (SELECT ${SessionQ.anyTutorIsHostingFutureSession()})`,
  'No Peer Reviews': SQL`${SessionQ.getComputedEndDate()} <= NOW()
      AND NOT EXISTS(SELECT 1 ${TutorAuditQ.where({ sessionId: SessionQ.id })})`,
  Audited: SQL`EXISTS(SELECT 1 ${TutorAuditQ.where({
    sessionId: SessionQ.id,
  })})`,
} as const

export const dateFilters = {
  Past: SQL`${SessionQ.start_date} < NOW()`,
  Upcoming: SQL`${SessionQ.start_date} > NOW()`,
  All: SQL`TRUE`,
} as const
